// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1AwsH","buttons":"PendingPaymentAlert_buttons__JTatZ"};